<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6">
        <LogTable />
      </div>
      <div class="col-12 col-lg-6">
        <EvaluationTable />
      </div>

    </div>
  </div>
</template>

<script>
import EvaluationList from './EvaluationList.vue'
import EvaluationTable from './EvaluationTable.vue'
import LogTable from './LogTable.vue'
import PredictionConfigEditor from './PredictionConfigEditor.vue'
export default {
  name: 'Dashboard',
  components: {
    EvaluationTable,
    PredictionConfigEditor,
    LogTable
  },
  props: {
  },
  data () {
    return {
      title: 'EvaluationDetail'
    }
  },
  methods: {
    back () {
      this.$emit ('backFromDetail', false)
    }
  },
  mounted () {
  }
}

</script>
